import React from 'react';
import classes from './WidgetContainer.module.scss';

interface IWidgetContainerProps {
  children: React.ReactNode;
  title?: string;
}

const WidgetContainer: React.FC<IWidgetContainerProps> = ({ children, title }) => {
  return (
    <div className={classes.WidgetContainer}>
      {title && <div className={classes.Title}>{title}</div>}
      <div className={classes.Content}>
        {children}
      </div>
    </div>
  );
};

export default WidgetContainer;
